import { type FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/buttons';
import { IconComponent } from '@/components/IconComponent';
import { ImageComponent } from '@/components/Image';
import { getTimeLeft } from '@/helpers/timer';
import { useToggle } from '@/hooks/common';
import { useNavigation } from '@/hooks/navigation';
import { HorizontalCountdown } from '@/modules/common/components/HorizontalCountdown';
import { useCMSConfig } from '@/modules/common/hooks/useCMSConfig';
import { useMissions } from '@/modules/promotions/mission/hooks/useMissions';
import { useModalsStore } from '@/store';
import { ScMissionPromoSection } from './styled';

export interface IMissionPromoSectionProps {
  onLinkClick?: () => void;
}

export const MissionPromoSection: FC<IMissionPromoSectionProps> = ({
  onLinkClick,
}) => {
  const { t } = useTranslation('mission');

  const { navigate } = useNavigation();

  const [isFullInfoOpen, toggleFullInfo] = useToggle();

  const open = useModalsStore.use.open();

  const handleButtonClick = useCallback(() => {
    onLinkClick?.();
    navigate('/mission');
  }, [onLinkClick, navigate, open]);

  const config = useCMSConfig();
  const timeLeft = getTimeLeft(config.data?.mission?.end || null);

  const { currentMission } = useMissions();
  if (!currentMission) return null;

  return (
    <ScMissionPromoSection
      onClick={toggleFullInfo}
      showFullInfo={isFullInfoOpen}
    >
      <div className="info">
        <div className="level-info">
          <div className="text">
            <span>
              <b className="reward">{t('reward')}</b>
            </span>
            <HorizontalCountdown timeLeft={timeLeft} />
          </div>
          <div className="addons">
            <div className="circle">
              <ImageComponent
                alt="character"
                className="character"
                height={44}
                src={currentMission.imgSrc}
                width={44}
              />
            </div>
            <IconComponent name="whiteArrowRight" size="18px" />
          </div>
        </div>
      </div>
      {isFullInfoOpen && (
        <Button className="loginBtn" navigation onClick={handleButtonClick}>
          {t('title')}
        </Button>
      )}
    </ScMissionPromoSection>
  );
};
